import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import Rating from '../../JobV3/Elements/Rating/Rating';
import './EmployerCard.scss';

export default class EmployerCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * Company Name
         */
        companyName: PropTypes.string,
        /**
         * Company Url
         */
        companyUrl: PropTypes.string,
        /**
         * company logo
         */
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        /**
         * company rating
         */
        rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * should Rating be linked to company ratings page
         */
        shouldLinkToRatings: PropTypes.bool,
        showUnderline: PropTypes.bool,
        linkable: PropTypes.bool,
    };

    static defaultProps = {
        linkable: true,
        showUnderline: true,
    };

    render() {
        const injectedTransforms = {
            xSmall: 'c_lpad,f_auto,q_auto,w_60,h_60',
        };

        let ratingDisplay = (
            <div className="no-reviews-box">No ratings yet</div>
        );
        const companyReviewUrl = this.props.linkable
            ? this.props.companyUrl.replace('company/jobs', 'company-reviews')
            : null;
        const imagePath = buildImagePath(
            this.props.logo.src,
            this.props.size || 'xSmall',
            injectedTransforms
        );
        if (Number(this.props.rating)) {
            ratingDisplay = (
                <div className="item-desc d-flex ratingArea">
                    <Rating rating={Number(this.props.rating)} />
                </div>
            );
            if (this.props.shouldLinkToRatings) {
                ratingDisplay = (
                    <a
                        className="item-desc d-flex ratingArea"
                        href={companyReviewUrl}
                    >
                        <Rating rating={Number(this.props.rating)} />
                    </a>
                );
            }
        }

        const underlineClass = this.props.showUnderline
            ? 'hasUnderline'
            : 'noUnderline';

        return (
            <div
                className={`component-Employer-EmployerCard ${underlineClass}`}
            >
                <div className="img">
                    {this.props.linkable ? (
                        <a href={this.props.companyUrl}>
                            <img src={imagePath} />
                        </a>
                    ) : (
                        <img src={imagePath} />
                    )}
                </div>
                <div className="info">
                    <div className="item-title">
                        {this.props.linkable ? (
                            <a href={this.props.companyUrl}>
                                {truncateWithEllipsis(
                                    this.props.companyName,
                                    52
                                )}
                            </a>
                        ) : (
                            truncateWithEllipsis(this.props.companyName, 52)
                        )}
                    </div>
                    {ratingDisplay}
                </div>
            </div>
        );
    }
}
